/*
 * @Author: edconstdchen
 * @Date:   2016-02-29 17:30:35
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-11-16 11:43:42
 */

import assert from 'assert';
import _ from 'lodash';
import defaultOptions from './defaultOptions';
import { MTT } from './jce/MTT4ServerProxy';
import HTMLTag from './HTMLTag';

export const { EContentFieldFlag } = MTT;
const ListFieldType = MTT.EContentFieldFlag;

/**
 * 是否listapp文章的行内元素
 * @param  {Number} type
 * @return {Boolean}
 */
function isInlineElement(type) {
  return [ListFieldType.ECFF_TEXT,
    ListFieldType.ECFF_LINK
  ].some(item => item === type);
}

/**
 * 生成ListApp文章的HTML
 * @param  {Array} contentFields     article from ListApp
 * @param  {Object} opts
 * @param  {Number} options.viewWidth 终端宽度
 * @return {String}
 */
function articleHTML(contentFields, opts) {
  assert(Array.isArray(contentFields), 'contentFields must be an array');

  const options = opts || {};
  assert(typeof options === 'object', 'options must be an object');
  _.defaultsDeep(options, defaultOptions);

  let IMMEDIATE_IMG_COUNT = options.IMMEDIATE_IMG_COUNT;

  let inline = false;
  const list = contentFields.map(item => {
    /* eslint no-param-reassign: 0 */
    const inlineElm = isInlineElement(item.eCff);
    let prefix = '';
    if (!inline && inlineElm) { // start inline
      prefix = '<p>';
      inline = true;
    }

    if (inline && !inlineElm) { // end inline
      prefix = '</p>';
      inline = false;
    }

    switch (item.eCff) {
      case ListFieldType.ECFF_TEXT:
        return prefix + HTMLTag.text(item.sVal);
      case ListFieldType.ECFF_LINK:
        return prefix + HTMLTag.link(item.sVal);
      case ListFieldType.ECFF_STRONG:
        return prefix + HTMLTag.strong(item.sVal);
      case ListFieldType.ECFF_IMG:
        {
          let src = item.sVal;
          if (src.indexOf('|') > -1) {
            // listapp old data
            // like 1024|768|http://read.html5.qq.com/image?xxxx
            const parts = src.split('|');
            if (parts.length > 2) {
              src = parts[2];
            }
          }
          item.sVal = src;
          item.lazy = (--IMMEDIATE_IMG_COUNT) < 0;
          return prefix + HTMLTag.image(item, _.extend(options.image, { apn: options.apn }));
        }
      case ListFieldType.ECFF_IMGTEXT:
        return prefix + HTMLTag.imageText(item.sVal);
      case ListFieldType.ECFF_VIDEO:
        return prefix + HTMLTag.video(item);
      case ListFieldType.ECFF_VIDEO_IFRAME:
        return prefix + HTMLTag.iframeVideo(item, options);
        // case ListFieldType.ECFF_ZH_AUTHOR:
        //     article.author.name = item.sVal;
        //     break;
        // case ListFieldType.ECFF_ZH_AUTHOR_URL:
        //     article.author.avatar = util.getProxyImageUrl(item.sVal, {
        //         referUrl: article.sUrl,
        //         w: avatarWidth
        //     });
        //     break;
        // case ListFieldType.ECFF_ZH_AUTHOR_DETAIL:
        //     article.author.intro = item.sVal;
        //     break;
      default:
        return prefix;
    }
  }).filter(Boolean);
  return HTMLTag.globalJS + list.join('');
}

export default articleHTML;



// WEBPACK FOOTER //
// ./src/index.js